import React, { useContext } from 'react'
import '../Token.css'
import { GlobalContext } from './../context/GlobalState'

export default function TokenGrid({ token }) {
    const {
        addTokenToPortfolio,
        portfolio,
        removeTokenFromPortfolio
    } = useContext(GlobalContext)
    const {
        name, 
        image,
        symbol,
        current_price,
        market_cap,
        market_cap_rank,
        total_volume,
        price_change_percentage_24h,
    } = token

    let storedToken = portfolio.find((o) => o.id === token.id);

    const portfolioDisabled = storedToken ? true : false
    
    return (
        <div className="token-container">
        {
            storedToken ?             
            <button 
            className="delete-button"
            
            onClick={() => removeTokenFromPortfolio(token)}
          >
            Remove from portfolio
          </button>
          :        
          <button className="add-button"
          disabled={portfolioDisabled}
          onClick={() => addTokenToPortfolio(token)}
          >Add to portfolio
          </button>
        }
        <div className="token-row">
        <p className="token-rank">Rank <br /> #{market_cap_rank}</p>
        <div className="token">
            <img src={image} alt="cryptocurrency-tokens" />
            <h1>{name}</h1>
            <h1 className="symbol">{symbol}</h1>
        </div>
        <div className="token-data">
            <p className="token-price">Price: <br/>${current_price}</p>
            {price_change_percentage_24h < 0 ? (
                <p className="token-percent red">Change %{price_change_percentage_24h.toFixed(2)}</p>
            ) : (
                <p className="token-percent green">Change %{price_change_percentage_24h.toFixed(2)}</p>
            )
            }
            <p className="token-marketcap">Market Cap: <br />{market_cap.toLocaleString()}</p>
            <p className="token-volume">Volume: <br />{total_volume.toLocaleString()}</p>
        </div>
    </div>
</div>
    )
}